import api from '~/services/api';
import { saidaProps, entradaProps } from '../types';

const createAjusteDePara = async (
  saida: saidaProps,
  entrada: entradaProps,
  cod_loja: number,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.post('/ajuste-de-para', {
    saida,
    entrada,
    cod_loja,
  });
  return data;
};

const deleteAjusteDePara = async (
  cod_ajuste_de_para: number,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.delete(`/ajuste-de-para/${cod_ajuste_de_para}`);
  return data;
};

export const ajusteDeParaServices = {
  createAjusteDePara,
  deleteAjusteDePara,
};
